import {Banner} from '@primer/react'

export type MoreResultsAvailableBannerProps = {
  itemsLabel: string
  maxItems: number
}

export function MoreResultsAvailableBanner({itemsLabel, maxItems}: MoreResultsAvailableBannerProps) {
  return (
    <div className="p-2">
      <Banner
        description={`Showing the first ${maxItems} ${itemsLabel}. To view additional ${itemsLabel.toLocaleString()}, please refine your search.`}
        hideTitle
        title={`More ${itemsLabel} available`}
      />
    </div>
  )
}
